
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0d3b66] text-white">
      {/* Newsletter Subscription */}
      <div className="max-w-7xl mx-auto px-6 pb-12">
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-2xl font-bold mb-3">Stay Updated</h3>
            <p className="text-white/80 mb-6">Subscribe to our newsletter for web design tips and special offers</p>
            <form 
              id="newsletter-form"
              data-readdy-form
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const emailInput = form.querySelector('input[name="email"]') as HTMLInputElement;
                const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                const messageDiv = document.getElementById('newsletter-message');
                
                if (!emailInput.value || !emailInput.validity.valid) {
                  if (messageDiv) {
                    messageDiv.className = 'mt-4 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-white text-sm';
                    messageDiv.textContent = 'Please enter a valid email address';
                  }
                  return;
                }
                
                submitBtn.disabled = true;
                submitBtn.innerHTML = '<i class="ri-loader-4-line animate-spin"></i> Subscribing...';
                
                const formData = new URLSearchParams();
                formData.append('email', emailInput.value);
                
                try {
                  const response = await fetch('https://readdy.ai/api/form/d50v802opjgqftil4isg', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: formData.toString()
                  });

                  if (response.ok) {
                    if (messageDiv) {
                      messageDiv.className = 'mt-4 p-3 bg-green-500/20 border border-green-500/50 rounded-lg text-white text-sm';
                      messageDiv.textContent = '✓ Successfully subscribed! Check your email for confirmation.';
                    }
                    emailInput.value = '';
                  } else {
                    throw new Error('Subscription failed');
                  }
                } catch (error) {
                  if (messageDiv) {
                    messageDiv.className = 'mt-4 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-white text-sm';
                    messageDiv.textContent = 'Something went wrong. Please try again.';
                  }
                } finally {
                  submitBtn.disabled = false;
                  submitBtn.innerHTML = '<i class="ri-send-plane-fill"></i> Subscribe';
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/30"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill"></i>
                Subscribe
              </button>
            </form>
            <div id="newsletter-message"></div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h4 className="text-2xl font-bold mb-6">BusinessWebsitePro</h4>
            <p className="text-white/80 mb-6 leading-relaxed">
              Professional website design services for small businesses across Canada, United States and Worldwide
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/transparency" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Transparency
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Booking
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Services */}
          <nav aria-label="Services">
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/starter-website" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Starter Website
                </Link>
              </li>
              <li>
                <Link to="/services/business-website" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Business Website
                </Link>
              </li>
              <li>
                <Link to="/services/premium-website" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Premium Website
                </Link>
              </li>
              <li>
                <Link to="/services/ecommerce" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  E-Commerce
                </Link>
              </li>
              <li>
                <Link to="/services/seo-services" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  SEO Services
                </Link>
              </li>
            </ul>
          </nav>
          
          {/* Service Area */}
          <div>
            <h4 className="text-lg font-bold mb-6">Service Area</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">Vancouver, BC</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">Toronto, ON</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">Calgary, AB</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">Across Canada</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-global-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">United States</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-earth-line text-lg flex-shrink-0 mt-1"></i>
                <span className="text-white/80">Worldwide</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              &copy; {new Date().getFullYear()} BusinessWebsitePro. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <Link to="/faq" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                FAQ
              </Link>
              <Link to="/blog" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                Blog
              </Link>
              <Link to="/contact" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                Contact
              </Link>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
